import VoltageChartPresenter from "./Chart/ChartVoltagePresenter";
import LastVoltagePresenter from "./LastVoltagePresenter";

export const Voltage = {
    Chart : VoltageChartPresenter,
    LastValue : LastVoltagePresenter
}

export default Voltage;